export interface IGridEditing {
    allowAdding: boolean;
    allowUpdating: boolean;
    allowDeleting: boolean;
}
